import UploadLessons from "../../components/lessons/UploadLessons";


const LessonsUpload = () => {
     return(
          <>
          <UploadLessons />
          </>
     )
};
export default  LessonsUpload;